"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TreePropertyBuilderModule = /** @class */ (function () {
    function TreePropertyBuilderModule() {
    }
    return TreePropertyBuilderModule;
}());
exports.TreePropertyBuilderModule = TreePropertyBuilderModule;
